const options = {
  data() {
    return {
      States: [
        "Alabama",
        "Alaska",
        "American Samoa",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Federated States of Micronesia",
        "Florida",
        "Georgia",
        "Guam",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Marshall Islands",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Northern Mariana Islands",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Palau",
        "Pennsylvania",
        "Puerto Rico",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virgin Island",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
      LandlordApplicationOptions: {
        reasonForApplyingOptions: [
          {
            "value": "Nonpayment of rent or fees (infrequent/recent issue)",
            "text": "Nonpayment of rent or fees (infrequent/recent issue)",
          },
          {
            "value": "End of lease",
            "text": "End of lease",
          },
          {
            "value": "Breach of lease",
            "text": "Breach of lease",
          },
          {
            "value": "Other issue(s) (please explain)",
            "text": "Other issue(s) (please explain)",
          },
        ],
      },
      DocumentUploadOptions: {
        documentsToUpload: [
          {
            "value": "Bank routing and account number",
            "text": "Bank routing and account number",
          },
          {
            "value": "Bank document (cancelled check or statement)",
            "text": "Bank document (cancelled check or statement)",
          },
          {
            "value": "Authorization documents (if not property owner)",
            "text": "Authorization documents (if not property owner)",
          },
          {
            "value": "Current W9",
            "text": "Current W9",
          },
        ],
      },
      TenantApplicationOptions: {
        reasonForApplyingOptions: [
          {
            "value": "Habitability/Repair Issues",
            "text": "Habitability/Repair Issues",
          },
          {
            "value": "I don't agree with the amount my landlord claims I owe",
            "text": "I don't agree with the amount my landlord claims I owe",
          },
          // {
          //   "value": "Arrears Dispute",
          //   "text": "Arrears Dispute",
          // },
          {
            "value": "End of lease",
            "text": "End of lease ",
          },
          // {
          //   "value": "Mistreatment/Abuse from Landlord",
          //   "text": "Mistreatment/Abuse from Landlord",
          // },
          // {
          //   "value": "Domestic Abuse (this information will remain confidential)",
          //   "text": "Domestic Abuse (this information will remain confidential)",
          // },
          {
            "value": "Other",
            "text": "Other",
          },
        ],
        paymentPeriod: [ "Weekly", "Biweekly", "Monthly", "Yearly"],
      },
      SurveyCheckboxOptions: {
        agreementIncludesOptions: [
          {
            "value": "Payment plan",
            "text": "Payment plan",
          },
          {
            "value": "A move out date",
            "text": "A move out date",
          },
          {
            "value": "Renewal of the lease",
            "text": "Renewal of the lease",
          },
          {
            "value": "Repairs",
            "text": "Repairs",
          },
          {
            "value": "Reduce or forgive back rent",
            "text": "Reduce or forgive back rent",
          },
          {
            "value": "Other",
            "text": "Other",
          },
        ],
        landlordNoAgreementOptions: [
          {
            "value": "The tenant was unavailable.",
            "text": "The tenant was unavailable.",
          },
          {
            "value": "We disagree over rent or other charges.",
            "text": "We disagree over rent or other charges.",
          },
          {
            "value": "The tenant does not have resources to pay ongoing rent.",
            "text": "The tenant does not have resources to pay ongoing rent.",
          },
          {
            "value": "Lack of rental assistance.",
            "text": "Lack of rental assistance.",
          },
          {
            "value": "There are issues other than rent.",
            "text": "There are issues other than rent.",
          },
          {
            "value": "Other",
            "text": "Other",
          },
        ],
        tenantNoAgreementOptions: [
          {
            "value": "We disagree over rent or other charges.",
            "text": "We disagree over rent or other charges.",
          },
          {
            "value": "I can’t afford the rent or payment plan.",
            "text": "I can’t afford the rent or payment plan.",
          },
          {
            "value": "I need rental assistance to help with back rent.",
            "text": "I need rental assistance to help with back rent.",
          },
          {
            "value": "The landlord or attorney does not have the info we need.",
            "text": "The landlord or attorney does not have the info we need.",
          },
          {
            "value": "Issues with contact information (could not contact)",
            "text": "Issues with contact information (could not contact)",
          },
          {
            "value": "There are issues other than rent.",
            "text": "There are issues other than rent.",
          },
          {
            "value": "Other",
            "text": "Other",
          },
        ],
        issuesOtherThanRent: [
          {
            "value": "Repairs and/or unsafe conditions",
            "text": "Repairs and/or unsafe conditions",
          },
          {
            "value": "Pets",
            "text": "Pets",
          },
          {
            "value": "Smoking",
            "text": "Smoking",
          },
          {
            "value": "Guests",
            "text": "Guests",
          },
          {
            "value": "Lease renewal or the term of the lease",
            "text": "Lease renewal or the term of the lease",
          },
        ],
      },
      MultipleChoiceFieldOptions: {
        Race: ['American Indian','Alaskan Native','Native Hawaiian or Other Pacific Islander',
          'Asian','Black or African American',
          'White','Other','Choose not to respond',
        ],
        Months: ["January","February","March","April","May","June","July",
          "August","September","October","November","December"],
        FeeTypes: ["Late", "Legal", "Repair", "Key", "Water", "Pet", "Security Deposit", "Application", "NSF", "Admin", "Parking"],
        Ethnicity: ["Non-Hispanic/Latino",
          "Hispanic/Latino",
          "Choose not to respond",
        ],
        Gender: ["Female",
          "Male",
          "Trans Woman (MTF)",
          "Trans Male (FTM)",
          "Gender Non-Conforming (i.e. not exclusively male or female)",
          "Choose not to respond",
        ],
        YesNo: ["Yes", "No"],
        //YesNoExpanded: ["Yes", "Maybe", "Unlikely", "No"],
        YesNoNotSure: ["Yes", "No", "Not Sure"],
        AgreementScale: ["Strongly Disagree", "Disagree", "Agree", "Strongly Agree"],
        //PaymentComfortScale: ["1: Very Comfortable", "2: Somewhat Comfortable", "3: Not Comfortable", "4: Very Uncomfortable"],
        Countries: [
          "United States",
          "Afghanistan",
          "Aland Islands",
          "Albania",
          "Algeria",
          "American Samoa",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antarctica",
          "Antigua and Barbuda",
          "Argentina",
          "Armenia",
          "Aruba",
          "Australia",
          "Austria",
          "Azerbaijan",
          "Bahamas",
          "Bahrain",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "Belgium",
          "Belize",
          "Benin",
          "Bermuda",
          "Bhutan",
          "Bolivia, Plurinational State of",
          "Bonaire, Sint Eustatius and Saba",
          "Bosnia and Herzegovina",
          "Botswana",
          "Bouvet Island",
          "Brazil",
          "British Indian Ocean Territory",
          "Brunei Darussalam",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Cambodia",
          "Cameroon",
          "Canada",
          "Cape Verde",
          "Cayman Islands",
          "Central African Republic",
          "Chad",
          "Chile",
          "China",
          "Christmas Island",
          "Cocos (Keeling) Islands",
          "Colombia",
          "Comoros",
          "Congo",
          "Congo, The Democratic Republic of the",
          "Cook Islands",
          "Costa Rica",
          "Cote d'Ivoire",
          "Croatia",
          "Cuba",
          "Curacao",
          "Cyprus",
          "Czech Republic",
          "Denmark",
          "Djibouti",
          "Dominica",
          "Dominican Republic",
          "Ecuador",
          "Egypt",
          "El Salvador",
          "Equatorial Guinea",
          "Eritrea",
          "Estonia",
          "Ethiopia",
          "Falkland Islands (Malvinas)",
          "Faroe Islands",
          "Fiji",
          "Finland",
          "France",
          "French Guiana",
          "French Polynesia",
          "French Southern Territories",
          "Gabon",
          "Gambia",
          "Georgia",
          "Germany",
          "Ghana",
          "Gibraltar",
          "Greece",
          "Greenland",
          "Grenada",
          "Guadeloupe",
          "Guam",
          "Guatemala",
          "Guernsey",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Heard Island and McDonald Islands",
          "Holy See (Vatican City State)",
          "Honduras",
          "Hong Kong",
          "Hungary",
          "Iceland",
          "India",
          "Indonesia",
          "Iran, Islamic Republic of",
          "Iraq",
          "Ireland",
          "Isle of Man",
          "Israel",
          "Italy",
          "Jamaica",
          "Japan",
          "Jersey",
          "Jordan",
          "Kazakhstan",
          "Kenya",
          "Kiribati",
          "Korea, Democratic People's Republic of",
          "Korea, Republic of",
          "Kosovo",
          "Kuwait",
          "Kyrgyzstan",
          "Lao People's Democratic Republic",
          "Latvia",
          "Lebanon",
          "Lesotho",
          "Liberia",
          "Libya",
          "Liechtenstein",
          "Lithuania",
          "Luxembourg",
          "Macao",
          "Macedonia, The Former Yugoslav Republic of",
          "Madagascar",
          "Malawi",
          "Malaysia",
          "Maldives",
          "Mali",
          "Malta",
          "Marshall Islands",
          "Martinique",
          "Mauritania",
          "Mauritius",
          "Mayotte",
          "Mexico",
          "Micronesia, Federated States of",
          "Moldova, Republic of",
          "Monaco",
          "Mongolia",
          "Montenegro",
          "Montserrat",
          "Morocco",
          "Mozambique",
          "Myanmar",
          "Namibia",
          "Nauru",
          "Nepal",
          "Netherlands",
          "New Caledonia",
          "New Zealand",
          "Nicaragua",
          "Niger",
          "Nigeria",
          "Niue",
          "Norfolk Island",
          "Northern Cyprus",
          "Northern Mariana Islands",
          "Norway",
          "Oman",
          "Pakistan",
          "Palau",
          "Palestine, State of",
          "Panama",
          "Papua New Guinea",
          "Paraguay",
          "Peru",
          "Philippines",
          "Pitcairn Islands",
          "Poland",
          "Portugal",
          "Puerto Rico",
          "Qatar",
          "Reunion",
          "Romania",
          "Russian Federation",
          "Rwanda",
          "Western Sahara",
          "Saint Barthelemy",
          "Saint Helena, Ascension and Tristan da Cunha",
          "Saint Kitts and Nevis",
          "Saint Lucia",
          "Saint Martin (French Part)",
          "Saint Pierre and Miquelon",
          "Saint Vincent and the Grenadines",
          "Samoa",
          "San Marino",
          "Sao Tome and Principe",
          "Saudi Arabia",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leone",
          "Singapore",
          "Sint Maarten (Dutch Part)",
          "Slovakia",
          "Slovenia",
          "Solomon Islands",
          "Somalia",
          "Somaliland",
          "South Africa",
          "South Georgia and the South Sandwich Islands",
          "South Ossetia",
          "South Sudan",
          "Spain",
          "Sri Lanka",
          "Sudan",
          "Suriname",
          "Svalbard and Jan Mayen",
          "Swaziland",
          "Sweden",
          "Switzerland",
          "Syrian Arab Republic",
          "Taiwan, Province of China",
          "Tajikistan",
          "Tanzania, United Republic of",
          "Thailand",
          "Timor-Leste",
          "Togo",
          "Tokelau",
          "Tonga",
          "Transnistria",
          "Trinidad and Tobago",
          "Tunisia",
          "Turkey",
          "Turkmenistan",
          "Turks and Caicos Islands",
          "Tuvalu",
          "Uganda",
          "Ukraine",
          "United Arab Emirates",
          "United Kingdom",
          "United States Minor Outlying Islands",
          "Uruguay",
          "Uzbekistan",
          "Vanuatu",
          "Venezuela, Bolivarian Republic of",
          "Vietnam",
          "Virgin Islands, British",
          "Virgin Islands, US",
          "Wallis and Futuna",
          "Yemen",
          "Zambia",
          "Zimbabwe",
        ],
        TitleOfPropertyManagementRepresentative: ["Property Management Company", "Agent"],
      },
      SubmitStatus: {
        Value: null,
        Options: {
          PENDING: "PENDING",
          OK: "OK",
          NOT_FOUND: "NOT_FOUND",
          ERROR: "ERROR",
        },
      },
      NumberOfTenants: 5,
      NumberOfChildren: 5,
      NumberOfLedgerEntries: 12,
    };
  },
};

export default options;
